export default __webpack_public_path__ + "static/media/05_hloh_d-min.7dd18f59.jpg";